<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

defineProps({
  labelMenuItems: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['updateLabel']);

const { t } = useI18n();

const showDropdown = ref(false);
</script>

<template>
  <div class="relative">
    <button class="flex items-center gap-2 input-base text-base bg-n-bluegray-4 text-white"
      :class="{ 'bg-n-alpha-2': showDropdown }" @click="showDropdown = !showDropdown">
      <span>
        {{ t('LABEL.TAG_BUTTON') }}
      </span>
      <span class="i-lucide-plus w-5 h-5" />
    </button>
    <DropdownMenu v-if="showDropdown" v-on-clickaway="() => (showDropdown = false)" :menu-items="labelMenuItems"
      show-search class="z-[100] w-48 mt-2 overflow-y-auto ltr:left-0 rtl:right-0 top-full max-h-52"
      @action="emit('updateLabel', $event)">
      <template #thumbnail="{ item }">
        <div class="rounded-sm size-2" :style="{ backgroundColor: item.thumbnail.color }" />
      </template>
    </DropdownMenu>
  </div>
</template>
